import { createContext, useContext } from 'react'

export type ProfileLayoutProperty = {
  profileNavHeight: number
}

export const ProfileLayoutPropertyContext =
  createContext<ProfileLayoutProperty>({
    profileNavHeight: 0,
  })

export const ProfileLayoutPropertyProvider =
  ProfileLayoutPropertyContext.Provider

export const useProfileLayoutProperty = () =>
  useContext(ProfileLayoutPropertyContext)
